import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const SourceWrapper = styled(FlexDiv)`
  gap: 8px;
`;

export const SourceData = styled(FlexDiv)`
  flex-direction: column;
`;

export const Count = styled(Typography)`
  font-size: 16px;
  font-family: var(--man-700);
  color: ${theme.colorsV2.gray.shade_800};
`;

export const SourceTitle = styled(Typography)`
  font-size: 16px;
  font-family: var(--man-700);
  color: ${theme.colorsV2.gray.shade_800};
`;

export const Link = styled(Typography)`
  font-size: 16px;
  font-family: var(--man-500);
  text-decoration: underline;
  color: ${theme.colorsV2.gray.shade_800};
  word-break: break-all;
`;
